<div class="block text-b4-l-500" (click)="openShopsModal()" data-analytics="avail_and_delivery">
  @if ((myShopService.activeShop$ | async) === undefined) {
    <span class="check-availability">наличие в магазинах</span>
    <span class="check-availability icon"><sd-icon type="arrow-next"></sd-icon></span>
  } @else if (myShopService.isMyShopStock(product().availableInStores) | async) {
    <span class="icon"><sd-icon type="success"></sd-icon></span>
    <span class="my-shop">в моем магазине</span>
  } @else {
    <span class="icon"><sd-icon type="arrow-next"></sd-icon></span>
    <span class="in-other-shops">в других магазинах</span>
  }
</div>
